import { render } from "./Concept_index_en_m.vue?vue&type=template&id=095142cf&scoped=true"
import script from "./Concept_index_en_m.vue?vue&type=script&lang=js"
export * from "./Concept_index_en_m.vue?vue&type=script&lang=js"

import "./Concept_index_en_m.vue?vue&type=style&index=0&id=095142cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-095142cf"

export default script